import Phaser from 'phaser'
import WorkArea from '../game/WorkArea';
import gameData from '../gameData';
import GameMenu from '../ui/GameMenu';
import MenuController from '../ui/MenuController';
import FinalScene from './FinalScene';

export default class MakeScene extends Phaser.Scene
{
    static get KEY() { return 'MakeScene'; }

    constructor()
    {
        super({ key: (MakeScene).KEY });
    }

    create()
    {
        this.workArea = new WorkArea(this);
        this.workArea.x = (this.scale.width / 2) - (this.workArea.width / 2);
        this.workArea.y = ~~(this.workArea.x / 2);
        this.add.existing(this.workArea);

        this.menu = new MenuController(this, this.workArea.backpackLayers.fullBackpackCanvasImage);
        this.add.existing(this.menu);

        this.hud = new GameMenu(this);

        this.selectedBackpack = 0;
        this.add.existing(this.hud);

        this.cameras.main.alpha = 0;
        this.tweens.add(
            {
                targets: this.cameras.main,
                duration: 1000,
                props: { alpha: 1 },
                ease: Phaser.Math.Easing.Quadratic.In
            }
        );
    }

    checkNewItemDropHit(sprite)
    {
        let stuck = false;
        // see if it hit backpack
        if (this.workArea.checkBackpackCollision(sprite))
        {
            stuck = true;
            this.workArea.addDragItem(sprite);
        }

        return stuck;
    }

    checkNewKeychainDropHit(sprite)
    {
        let stuck = false;
        // see if it hit backpack
        if (this.workArea.checkBackpackCollision(sprite.handle))
        {
            stuck = true;
            this.workArea.addKeychainItem(sprite);
        }

        return stuck;
    }

    doStartOver()
    {
        this.workArea.changeMainItem(0);
    }

    allDone(e)
    {
        this.nextScene();
    }

    nextScene()
    {
        this.workArea.saveUserBackpack();
        gameData.selectedType = this.selectedBackpack;

        this.tweens.add(
            {
                targets: this.cameras.main,
                duration: 1000,
                props: { alpha: 0 },
                ease: Phaser.Math.Easing.Quadratic.Out,
                onComplete: () => this.scene.start(FinalScene.KEY)
            }
        );
    }

    switchBackgroundItem(index)
    {
        this.workArea.changeMainItem(index);
        this.selectedBackpack = index;
    }

    setPatternType(itemIndex)
    {
        let value = "game-assets/PATTERN+" + (itemIndex + 1);
        this.workArea.drawPattern(itemIndex, value);
    }

    setColorFillType(value)
    {
        this.workArea.setFillType(value);
    }

    colorBackpack(colorInfo)
    {
        this.workArea.colorBackpack(colorInfo);
    }
}